<template>
  <div class="home mt-3">
    <filtros-box
      entidad="Servicios"
      :show-descargar="true"
      @descargar="getServiciosExcel"
      @modelActivo="servicio_activo = $event"
      @model="servicio_sel = $event"
      @desplegarFiltros="cargarFiltros"
      @muestraModal="showEdit($event[0], $event[1])"
      @buscar="serviciosBuscar()"
    >
    </filtros-box>


    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>
    <data-table
      v-if="serviciosBusqueda && serviciosBusqueda.data && serviciosBusqueda.data.length"
      :columns="columns"
      :data="serviciosBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_servicio"
      actions-width="140"
      @sort="orderByfield"
    >
      <template #cell-keyword_desc="{ item }">
        {{ item.keyword_desc || '-' }}
        <small class="idEntity" v-if="item.id_keyword">(ID:{{ item.id_keyword }})</small>
      </template>

      <template #cell-producto="{ item }">
        {{ item.producto }}
        <small class="idEntity" v-if="item.id_producto">(ID:{{ item.id_producto }})</small>
      </template>

      <template #cell-numero_visible="{ item }">
        {{ item.numero_visible }}
        <small class="idEntity" v-if="item.id_operador">(ID:{{ item.id_operador }})</small>
      </template>

      <template #cell-descripcion="{ item }">
        {{ item.descripcion }}
        <small class="idEntity" v-if="item.id_tipo_suscripcion">(ID:{{ item.id_tipo_suscripcion }})</small>
      </template>

      <template #actions="{ item }">
        <nobr>
          <button
            type="button"
            class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
            data-toggle="tooltip"
            data-placement="top"
            title="Atributos del servicio"
            @click="openAtributosModal(item)"
          >
            <small class="bi-bar-chart-steps"></small>
          </button>
          <button
            class="btn btn-primary btn-sm mr-1 pt-0 pb-1"
            data-toggle="tooltip"
            data-placement="top"
            title="Editar Servicio"
            @click="showEdit(item, 'edit')"
          >
            <small class="bi-pencil-fill"></small>
          </button>
          <button
            :class="
              item.activo == '1'
                ? 'btn btn-warning btn-sm pt-0 pb-1'
                : 'btn btn-success btn-sm pt-0 pb-1'
            "
            data-toggle="tooltip"
            data-placement="top"
            :title="
              item.activo == '1'
                ? 'Suspender Servicio'
                : 'Reactivar Servicio'
            "
            @click="showEdit(item, 'toggle')"
          >
            <small
              :class="item.activo == '1' ? 'bi-pause' : 'bi-play'"
            ></small>
          </button>
        </nobr>
      </template>
    </data-table>
    <empty-state
      :show="Boolean(post && serviciosBusqueda && serviciosBusqueda.data && !serviciosBusqueda.data.length)"
      message="No se encontraron servicios que coincidan con la búsqueda."
    />
    <Paginador
      v-if="serviciosBusqueda && serviciosBusqueda.pages"
      :pages="serviciosBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <div
      v-if="
        !(
          serviciosBusqueda &&
          serviciosBusqueda.data &&
          serviciosBusqueda.data.length
        ) && post
      "
    >
      <div class="alert alert-info">
        No se obtubieron atributos con el criterio seleccionado.
      </div>
    </div>
    <!-- Modal Flotante de Atributos -->
    <div v-if="showAtributosModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
              <div class="modal-content shadow-lg border-0">
                <div class="modal-header bg-dark text-white">
                  <h5 class="modal-title">
                    <i class="bi bi-bar-chart-steps mr-2"></i>Atributos del Servicio: <b>{{ selectedServicioAtributos ? (selectedServicioAtributos.servicio || selectedServicioAtributos.alias || ('ID: ' + selectedServicioAtributos.id_servicio)) : '' }}</b>
                  </h5>
                  <button type="button" class="close text-white" aria-label="Cerrar" @click="closeAtributosModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body p-3">
                  <Atributos
                    v-if="selectedServicioAtributos"
                    :propServicio="selectedServicioAtributos.id_servicio"
                    :propProducto="selectedServicioAtributos.id_producto"
                    :propOperador="selectedServicioAtributos.id_operador"
                    :propTipoSuscripcion="selectedServicioAtributos.id_tipo_suscripcion"
                    :isModal="true"
                  />
                </div>
                <div class="modal-footer py-2">
                  <button type="button" class="btn btn-secondary btn-sm" @click="closeAtributosModal">
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-dialog-scrollable modal-lg"
              role="document"
              :class="
                operation == 'jerarquia'
                  ? 'modal-lg modal-dialog-scrollable'
                  : ''
              "
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'toggle'" class="modal-title">
                    <span v-if="editData.activo == 1"> Suspender Servicio</span>
                    <span v-if="editData.activo == 0"> Reactivar Servicio</span>
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">
                    Editar Servicio {{ editData.id_servicio }}
                  </h5>
                  <h5 v-if="operation == 'add'" class="modal-title">
                    Nuevo Servicio
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <ul
                    v-if="operation == 'edit' || operation == 'add'"
                    class="nav nav-tabs"
                    id="modal_title_tabs_users"
                    role="tablist"
                  >
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        v-bind:class="{ 'active': incompleto  }"

                        id="info_basic-tab"
                        data-toggle="tab"
                        href="#info_basic"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Información básica</a
                      >
                    </li>

                    <li class="nav-item" v-if="operation == 'add'">
                      <a
                        class="nav-link"
                        v-bind:class="{ 'disabled': incompleto, 'active': !incompleto  }"
                        id="info_cobro-tab"
                        data-toggle="tab"
                        href="#info_cobro"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                        >Reglas de cobro</a
                      >
                    </li>
                  </ul>
                  <form v-if="operation == 'edit' || operation == 'add'">
                    <div class="tab-content" id="myTabContent">
                      <div
                        class="tab-pane fade"

                        v-bind:class="{ 'show': incompleto, 'active': incompleto  }"


                        id="info_basic"
                        role="tabpanel"
                        aria-labelledby="info_basic"
                      >
                        <br />

                
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="tipo_suscripcion_select"
                                >Tipo Suscripción</label
                              >
                              <select
                                class="form-control"
                                id="tipo_susc_select"
                                name="id_tipo_suscripcion"
                                v-model="editData.id_tipo_suscripcion"
                            :disabled="operation == 'edit' || disabled_id_tipo_suscripcion"
                              >
                                <option :value="null">Seleccionar</option>
                                <option
                                  v-for="tiposuscItem in (tipoSuscripciones && tipoSuscripciones.data ? tipoSuscripciones.data : (tipoSuscripciones || []))"
                                  v-bind:key="tiposuscItem.id_tipo_suscripcion"
                                  v-bind:value="tiposuscItem.id_tipo_suscripcion"
                                >
                                  {{ tiposuscItem.descripcion || tiposuscItem.alias || tiposuscItem.tipo_suscripcion }}
                                </option>
                                <option value="20" v-if="!tipoSuscripciones || (Array.isArray(tipoSuscripciones) && !tipoSuscripciones.length) || (tipoSuscripciones.data && !tipoSuscripciones.data.length)">Servicios de SDP</option>
                              </select>
                              <small class="form-text text-muted">Tipo de suscripción (ej: Servicios de SDP, Suscripcion periodica 24hs).</small>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Operador</label>

                              <select
                                class="form-control"
                                id="operador_select"
                                name="id_operador"
                                v-model="editData.id_operador"
                            :disabled="operation == 'edit' || disabled_id_operador"
                              >
                                <option :value="null">Seleccionar</option>
                                <option
                                  v-for="operadorSel in (operadoresBusqueda && operadoresBusqueda.data ? operadoresBusqueda.data : (operadoresBusqueda || []))"
                                  v-bind:key="operadorSel.id_operador"
                                  v-bind:value="operadorSel.id_operador"
                                >
                                  {{ operadorSel.operador }}
                                </option>
                              </select>
                              <small class="form-text text-muted">Operador y numeración corta asociada.</small>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Producto</label>
                              <select
                                class="form-control"
                                id="producto_select"
                                name="id_producto"
                                v-model="editData.id_producto"
                            :disabled="operation == 'edit' || disabled_id_producto"
                              >
                               <option :value="null">Seleccionar</option>
                                <option
                                  v-for="productoItem in (productos && productos.data ? productos.data : (productos || []))"
                                  v-bind:key="productoItem.id_producto"
                                  v-bind:value="productoItem.id_producto"
                                >
                                  {{ productoItem.producto }}
                                </option>
                              </select>
                              <small class="form-text text-muted">Producto asignado al servicio.</small>
                            </div>
                          </div>
                           <div class="col-md-6">
                            <div class="form-group">
                              <label>Keywords</label>
                              <select
                                class="form-control"
                                id="keyword_select"
                                name="id_keyword"
                                v-model="editData.id_keyword"
                              :disabled="operation == 'edit' || disabled_id_keyword"
                              >
                               <option :value="null">Seleccionar</option>
                                <option
                                  v-for="keywordItem in (keywordsBusqueda && keywordsBusqueda.data ? keywordsBusqueda.data : (keywordsBusqueda || []))"
                                  v-bind:key="keywordItem.id_keyword"
                                  v-bind:value="keywordItem.id_keyword"
                                >
                                  {{ keywordItem.keyword }}
                                </option>
                              </select>
                              <small class="form-text text-muted">Palabra clave disparadora del servicio.</small>
                            </div>
                          </div>
                          
                        </div>
                      </div>









                      <div
                        class="tab-pane fade xml-5"
                                                v-bind:class="{ 'show': !incompleto, 'active': !incompleto  }"

                        id="info_cobro"
                        role="tabpanel"
                        aria-labelledby="info_cobro-tab"
                      >
                        <br />



                          

   <div
                          v-if="operation == 'edit' || operation == 'add'"
                          class="form-group"
                        >
                         
                           <label for="url_club"> Secuencia de Cobro 

                                <span v-if="atributosServ.billing_sequence_id || (
                                  !atributos.billing_sequence_id &&
                                  !atributosOp.billing_sequence_id &&
                                  !atributosTipoSusc.billing_sequence_id &&
                                  !atributosDefault.billing_sequence_id) ">(Editando a Nivel Servicio)</span>
                                <span v-else-if="atributos.billing_sequence_id && atributos.billing_sequence_id != ''">(Hereda de Producto)</span>
                                <span v-else-if="atributosOp.billing_sequence_id  && atributosOp.billing_sequence_id != ''">(Hereda Operador)</span>
                                <span v-else-if="atributosTipoSusc.billing_sequence_id  && atributosTipoSusc.billing_sequence_id != ''">(Hereda de Tipo Suscripción)</span>
                                <span v-else-if="atributosDefault.billing_sequence_id  && atributosDefault.billing_sequence_id != ''">(Hereda por Default)</span>

                              </label> 

                               <a class="btn btn-sm float-right" 
                                v-bind:class="{ 'd-none': atributosServ.billing_sequence_id }"


                              @click="
                              atributosServ.billing_sequence_id=billing_sequence_select,
                              disabled_secuencia = toggleEdit(disabled_secuencia)
                              ">Modificar</a>
                          <select
                            class="form-control"
                            v-model="billing_sequence_select"
                            aria-label="Secuencia de Cobro"
                            @change="getCuadroBilling(billing_sequence_select)"
                            :disabled="operation == 'edit' || disabled_secuencia"
                          >
                            <option selected="select" value="">
                              Valor no seleccionado
                            </option>
                            <option
                              v-for="billing in (billingsequences && billingsequences.data ? billingsequences.data : (billingsequences || []))"
                              v-bind:key="billing.id_billing_sequence"
                              v-bind:value="billing.id_billing_sequence"
                            >
                              {{ billing.descripcion || billing.sequence }}
                            </option>
                          </select>
                        </div>




                        


                          <div v-if="cuadro.precioFinal" class="container">
                            <fieldset style="width: 100%; margin: 5px auto">
                              <div
                                class="infoGral"
                                style="margin-bottom: 4px; overflow: auto"
                              >
                                <div class="fl-left al-left" style="width: 50%">
                                  <strong>Precio final: </strong
                                  ><span id="full_price">{{
                                    cuadro.precioFinal
                                  }}</span>
                                </div>
                                <div class="fl-left al-left" style="width: 50%">
                                  <strong>Cobros:</strong
                                  ><span id="cobros">{{ cuadro.cobros }}</span>
                                </div>
                                <div
                                  class="fl-left al-left"
                                  style="width: 100%"
                                >
                                  <strong>id Secuencia: </strong
                                  ><span id="id_secuence">{{
                                    cuadro.id_billing_sequence
                                  }}</span>
                                </div>
                              </div>
                              <h4 style="font-size: 12px">
                                Payments utilizados
                              </h4>
                              <div
                                class="dataTables_wrapper"
                                id="fullPriceSequenceDetailsTable_wrapper"
                              >
                                <div
                                  class="
                                    fg-toolbar
                                    ui-toolbar
                                    ui-widget-header
                                    ui-corner-tl
                                    ui-corner-tr
                                    ui-helper-clearfix
                                  "
                                ></div>
                                <table
                                  class="
                                    table
                                    xtable-responsive
                                    table-striped
                                    xtable-fixed
                                    table-sm
                                  "
                                  style="width: 100%"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        class="ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          #<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-triangle-1-n
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Código TAS<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="al-right ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Precio s/imp.<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                      <th
                                        class="al-right ui-state-default"
                                        rowspan="1"
                                        colspan="1"
                                        style="width: 0px"
                                      >
                                        <div class="DataTables_sort_wrapper">
                                          Precio c/imp.<span
                                            class="
                                              DataTables_sort_icon
                                              css_right
                                              ui-icon ui-icon-carat-2-n-s
                                            "
                                          ></span>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      class="odd tpar"
                                      v-for="payment in cuadro.payments"
                                      v-bind:key="payment.id_billing_code || payment.id"
                                    >
                                      <td class="sorting_1">
                                        {{ payment.id_billing_code || payment.id }}
                                      </td>
                                      <td>{{ payment.cod_tas || '-' }}</td>
                                      <td class="al-right">
                                        ${{ payment.precio_sin_imp || payment.precioSinImp }}
                                      </td>
                                      <td class="al-right">
                                        ${{ payment.precio_con_imp || payment.precioConImp }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div
                                  class="
                                    fg-toolbar
                                    ui-toolbar
                                    ui-widget-header
                                    ui-corner-bl
                                    ui-corner-br
                                    ui-helper-clearfix
                                  "
                                ></div>
                              </div>
                            </fieldset>
                          </div>





                      </div>







                    </div>

                    <div v-if="errors" class="alert alert-danger my-2" role="alert">
                      <i class="bi bi-exclamation-triangle me-1"></i>
                      {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
                    </div>
                  </form>
                  <p v-if="operation == 'toggle'">
                    Esta seguro de realizar esta acción?
                  </p>
                  <div
                    v-if="errors && operation != 'add' && operation != 'edit'"
                    class="alert alert-danger my-2"
                    role="alert"
                  >
                    <i class="bi bi-exclamation-triangle me-1"></i>
                    {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
                  </div>
                </div>
                <div class="modal-footer">

                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >
                    <span v-if="operation == 'jerarquia'">Cerrar</span>
                    <span v-else>Cancelar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'edit'"
                    @click="editServicio"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'add' && incompleto"
                    @click="checkpaso1"
                    class="btn btn-primary"
                  >
                    Siguiente
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'add' && !incompleto"
                    @click="agregarServicio"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import filtrosBox from "./utiles/filtrosBox.vue";
import DataTable from "./utiles/DataTable.vue";
import EmptyState from "./utiles/EmptyState.vue";
import Atributos from "./Atributos.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { fetchCachedCatalog } from "../../utils/filterCache";
import { startAsyncExport } from "@/utils/exportHelper";

export default {

  name: "Home",
  mixins: [tableSortMixin],

  data() {
    return {
      columns: [
        { label: "Id", field: "id", width: "80" },
        { label: "Keyword", field: "keyword_desc" },
        { label: "Producto", field: "producto" },
        { label: "Número", field: "numero_visible" },
        { label: "Tipo", field: "descripcion" },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      showAtributosModal: false,
      selectedServicioAtributos: null,
      disabled: 0,
        
      success: null,
      tipoSuscripciones: [],
      id_operador_sel: null,
      id_tipo_suscripcion_sel: null,
      error: null,
      ocultotabla: false,
      tipos: ["SEQ", "RND"],
      categorias: "",
      alias_sel: null,
      id_categoria_sel: [],
      id_integrador_sel: parseInt(localStorage.getItem("integrador")),
      servicio_sel: null,
      servicio_activo: null,
      serviciosBusqueda: null,
      post: false,
      showModal: false,
      editData: [],
      operation: null,
      page: 1,
      errors: [],
      productosBusqueda: [],
      keywordsBusqueda: [],
      pages: null,
      atributos: [],
      atributosOp:[],
      atributosTipoSusc:[],
      atributosServ:[],
      atributosDefault:[],
      atributosFinal:[],
      cuadro: [],
      billing_sequence_select: "",
      billingSequence: null,
      billingsequences: null,
      incompleto:true,
      disabled_id_tipo_suscripcion:false,
      disabled_id_operador:false,
      disabled_id_producto:false,
      disabled_id_keyword:false,
      billRestriction:null,
      scPayments:null,
      scFrequency:null,
      scLifetime:null,
      scPrice:null,
      scPriceImp:null,
      disabled_secuencia:false,
      disabled_url_club:false,
      disabled_try_and_buy:false,
      disabled_mail_aprobacion:false,
      disabled_pin_message:false,
      disabled_optin_message:false,
      disabled_apigw_v2t_service:false,
      disabled_apigw_use_rbt:false,
      disabled_apigw_iscustomer_keyword:false,
      disabled_apigw_invoce_charge_code:false,
      disabled_already_message:false,
      disabled_crossselling_unsubscribe_message:false,
      attribu:{
      'billing_sequence_id':'',
      'apigw_v2t_service':'',
      'apigw_use_rbt':'',
      'apigw_iscustomer_keyword':'',
      'apigw_invoce_charge_code':'',
      'try_and_buy':'',
      'crossselling_unsubscribe_message':'',
      'url_club':'',
      'pin_message':'',
      'optin_message':'',
      'mail_aprobacion':'',
      'already_message':''},
      valor: null,
      id_servicio: null,
      operadoresBusqueda: [],
      productos: [],
      atributosProd: [],
    };
  },


  components: {
    DataTable,
    EmptyState,
    Paginador,
    filtrosBox,
    Atributos,
  },




  created() {
    this.ocultotabla = false;
    this.getServiciosBusqueda();
  },

  computed: {
    ...mapGetters("auth", ["user"]),
  },

  methods: {
    cargarFiltros: function (forceRefresh = false) {
      this.id_integrador_sel = parseInt(localStorage.getItem("integrador"));
      return Promise.allSettled([
        this.getCategorias(forceRefresh),
        this.getBillinSequences(forceRefresh),
        this.getTipodeSuscripcinesBusqueda(true, forceRefresh),
        this.getOperadoresBusqueda(true, forceRefresh),
        this.getProductosBusqueda(true, forceRefresh),
        this.getKeywordsBusqueda(true, forceRefresh)
      ]);
    },

    serviciosBuscar: function () {
      this.changePage(1);
    },

    changePage: function (page) {
      this.page = page;
      this.getServiciosBusqueda(false);
    },



    cargaBillingBox: function () {
      this.ocultotabla = !this.ocultotabla;
    },

    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getServiciosBusqueda(false);
    },

    getServiciosExcel: function () {
      startAsyncExport("servicio", {
        id_integrador: this.id_integrador_sel,
        order_by: {
          field: this.orderByField,
          order: this.orderByDirection,
        },
      }, "Servicios");
    },


    getServiciosBusqueda: function (hideResult = true) {
      if (hideResult) this.serviciosBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "servicio/busqueda", {
          page: this.page,
          id_integrador: this.id_integrador_sel,
          servicio: this.servicio_sel,
          activo: this.servicio_activo,

          order_by: { field: this.orderByField, order: this.orderByDirection },
        })
        .then((response) => {
          this.serviciosBusqueda = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
           if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar los servicios",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    getTipodeSuscripcinesBusqueda: function (hideResult = true, forceRefresh = false) {
      if (hideResult) this.tipoSuscripciones = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "tipoSuscripcion/busqueda", {
        get_all: true,
        activo: 1,
        order_by: { field: "id_tipo_suscripcion", order: "ASC" },
      }, forceRefresh)
        .then((response) => {
          this.tipoSuscripciones = (response && response.data) ? (response.data.data || response.data) : [];
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.post = true;
        });
    },
    getOperadoresBusqueda: function (hideResult = true, forceRefresh = false) {
      if (hideResult) this.operadoresBusqueda = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "operador/busqueda", {
        id_integrador: this.id_integrador_sel,
        get_all: true,
        activo: 1,
        order_by: { field: "id_operador", order: "ASC" },
      }, forceRefresh)
        .then((response) => {
          this.operadoresBusqueda = (response && response.data) ? (response.data.data || response.data) : [];
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.post = true;
        });
    },




         getAtributosProducto(id) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "producto/atributos",{
          id_producto: id,
        })
        .then((response) => {
          this.atributos = response.data;
          this.billing_sequence_select = this.atributos.billing_sequence_id;
          this.billingscPayments = this.atributos.billing_sequence_id;
          this.getCuadroBilling(this.billing_sequence_select);


if (this.atributos.pin_message) {
  this.atributosFinal.pin_message = this.atributos.pin_message;
}else if(this.atributosOp.pin_message){
  this.atributosFinal.pin_message = this.atributosOp.pin_message;
}else if(this.atributosTipoSusc.pin_message){
  this.atributosFinal.pin_message = this.atributosTipoSusc.pin_message;
}else if(this.atributosDefault.pin_message){
  this.atributosFinal.pin_message = this.atributosDefault.pin_message;
}
this.disabled_pin_message=this.atributosFinal.pin_message;

if (this.atributos.optin_message) {
  this.atributosFinal.optin_message = this.atributos.optin_message;
}else if(this.atributosOp.optin_message){
  this.atributosFinal.optin_message = this.atributosOp.optin_message;
}else if(this.atributosTipoSusc.optin_message){
  this.atributosFinal.optin_message = this.atributosTipoSusc.optin_message;
}else if(this.atributosDefault.optin_message){
  this.atributosFinal.optin_message = this.atributosDefault.optin_message;
}
this.disabled_optin_message=this.atributosFinal.optin_message;


if (this.atributos.already_message) {
  this.atributosFinal.already_message = this.atributos.already_message;
}else if(this.atributosOp.already_message){
  this.atributosFinal.already_message = this.atributosOp.already_message;
}else if(this.atributosTipoSusc.already_message){
  this.atributosFinal.already_message = this.atributosTipoSusc.already_message;
}else if(this.atributosDefault.already_message){
  this.atributosFinal.already_message = this.atributosDefault.already_message;
}
this.disabled_already_message=this.atributosFinal.already_message;



if (this.atributos.mail_aprobacion) {
  this.atributosFinal.mail_aprobacion = this.atributos.mail_aprobacion;
}else if(this.atributosOp.mail_aprobacion){
  this.atributosFinal.mail_aprobacion = this.atributosOp.mail_aprobacion;
}else if(this.atributosTipoSusc.mail_aprobacion){
  this.atributosFinal.mail_aprobacion = this.atributosTipoSusc.mail_aprobacion;
}else if(this.atributosDefault.mail_aprobacion){
  this.atributosFinal.mail_aprobacion = this.atributosDefault.mail_aprobacion;
}
this.disabled_mail_aprobacion=this.atributosFinal.mail_aprobacion;


if (this.atributos.url_club) {
  this.atributosFinal.url_club = this.atributos.url_club;
}else if(this.atributosOp.url_club){
  this.atributosFinal.url_club = this.atributosOp.url_club;
}else if(this.atributosTipoSusc.url_club){
  this.atributosFinal.url_club = this.atributosTipoSusc.url_club;
}else if(this.atributosDefault.url_club){
  this.atributosFinal.url_club = this.atributosDefault.url_club;
}
this.disabled_url_club=this.atributosFinal.url_club;


if (this.atributos.crossselling_unsubscribe_message) {
  this.atributosFinal.crossselling_unsubscribe_message = this.atributos.crossselling_unsubscribe_message;
}else if(this.atributosOp.crossselling_unsubscribe_message){
  this.atributosFinal.crossselling_unsubscribe_message = this.atributosOp.crossselling_unsubscribe_message;
}else if(this.atributosTipoSusc.crossselling_unsubscribe_message){
  this.atributosFinal.crossselling_unsubscribe_message = this.atributosTipoSusc.crossselling_unsubscribe_message;
}else if(this.atributosDefault.crossselling_unsubscribe_message){
  this.atributosFinal.crossselling_unsubscribe_message = this.atributosDefault.crossselling_unsubscribe_message;
}
this.disabled_crossselling_unsubscribe_message=this.atributosFinal.crossselling_unsubscribe_message;

if (this.atributos.try_and_buy) {
  this.atributosFinal.try_and_buy = this.atributos.try_and_buy;
}else if(this.atributosOp.try_and_buy){
  this.atributosFinal.try_and_buy = this.atributosOp.try_and_buy;
}else if(this.atributosTipoSusc.try_and_buy){
  this.atributosFinal.try_and_buy = this.atributosTipoSusc.try_and_buy;
}else if(this.atributosDefault.try_and_buy){
  this.atributosFinal.try_and_buy = this.atributosDefault.try_and_buy;
}
this.disabled_try_and_buy=this.atributosFinal.try_and_buy;



if (this.atributos.apigw_invoce_charge_code) {
  this.atributosFinal.apigw_invoce_charge_code = this.atributos.apigw_invoce_charge_code;
}else if(this.atributosOp.apigw_invoce_charge_code){
  this.atributosFinal.apigw_invoce_charge_code = this.atributosOp.apigw_invoce_charge_code;
}else if(this.atributosTipoSusc.apigw_invoce_charge_code){
  this.atributosFinal.apigw_invoce_charge_code = this.atributosTipoSusc.apigw_invoce_charge_code;
}else if(this.atributosDefault.apigw_invoce_charge_code){
  this.atributosFinal.apigw_invoce_charge_code = this.atributosDefault.apigw_invoce_charge_code;
}
this.disabled_apigw_invoce_charge_code=this.atributosFinal.apigw_invoce_charge_code;

if (this.atributos.apigw_iscustomer_keyword) {
  this.atributosFinal.apigw_iscustomer_keyword = this.atributos.apigw_iscustomer_keyword;
}else if(this.atributosOp.apigw_iscustomer_keyword){
  this.atributosFinal.apigw_iscustomer_keyword = this.atributosOp.apigw_iscustomer_keyword;
}else if(this.atributosTipoSusc.apigw_iscustomer_keyword){
  this.atributosFinal.apigw_iscustomer_keyword = this.atributosTipoSusc.apigw_iscustomer_keyword;
}else if(this.atributosDefault.apigw_iscustomer_keyword){
  this.atributosFinal.apigw_iscustomer_keyword = this.atributosDefault.apigw_iscustomer_keyword;
}
this.disabled_apigw_iscustomer_keyword=this.atributosFinal.apigw_iscustomer_keyword;


if (this.atributos.apigw_use_rbt) {
  this.atributosFinal.apigw_use_rbt = this.atributos.apigw_use_rbt;
}else if(this.atributosOp.apigw_use_rbt){
  this.atributosFinal.apigw_use_rbt = this.atributosOp.apigw_use_rbt;
}else if(this.atributosTipoSusc.apigw_use_rbt){
  this.atributosFinal.apigw_use_rbt = this.atributosTipoSusc.apigw_use_rbt;
}else if(this.atributosDefault.apigw_use_rbt){
  this.atributosFinal.apigw_use_rbt = this.atributosDefault.apigw_use_rbt;
}
this.disabled_apigw_use_rbt=this.atributosFinal.apigw_use_rbt;


if (this.atributos.apigw_v2t_service) {
  this.atributosFinal.apigw_v2t_service = this.atributos.apigw_v2t_service;
}else if(this.atributosOp.apigw_v2t_service){
  this.atributosFinal.apigw_v2t_service = this.atributosOp.apigw_v2t_service;
}else if(this.atributosTipoSusc.apigw_v2t_service){
  this.atributosFinal.apigw_v2t_service = this.atributosTipoSusc.apigw_v2t_service;
}else if(this.atributosDefault.apigw_v2t_service){
  this.atributosFinal.apigw_v2t_service = this.atributosDefault.apigw_v2t_service;
}
this.disabled_apigw_v2t_service=this.atributosFinal.apigw_v2t_service;









        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
             getAtributosOperador(id) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "operador/atributos",{
          id_operador: id,
        })
        .then((response) => {
          this.atributosOp = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

             getAtributosTipoSusc(id) {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "tipoSuscripcion/atributos",{
          id_tipo_suscripcion: id,
        })
        .then((response) => {
                    this.atributosTipoSusc = response.data;


        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.activo = 1 - this.editData.activo;
      axios
        .post(process.env.VUE_APP_API_URL + "servicio/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Servicio actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          const resData = e.response && e.response.data;
          if (resData) {
            let errorMsg = resData.error || "Ha ocurrido un error al intentar guardar";
            if (resData.errors && typeof resData.errors === "object" && Object.keys(resData.errors).length > 0) {
              const details = Object.entries(resData.errors)
                .map(([field, errs]) => `${field}: ${Array.isArray(errs) ? errs.join(", ") : errs}`)
                .join(" | ");
              errorMsg += ` (${details})`;
            }
            this.errors = errorMsg;
            Swal.fire({
              title: "Error!",
              text: errorMsg,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getServiciosBusqueda();
        });
    },

    editServicio: function () {
      this.errors = null;
      delete this.editData.atributos;
      this.$store.commit("setLoading", true);

      axios
        .post(process.env.VUE_APP_API_URL + "servicio/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Servicio actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          const resData = e.response && e.response.data;
          if (resData) {
            let errorMsg = resData.error || "Ha ocurrido un error al intentar guardar";
            if (resData.errors && typeof resData.errors === "object" && Object.keys(resData.errors).length > 0) {
              const details = Object.entries(resData.errors)
                .map(([field, errs]) => `${field}: ${Array.isArray(errs) ? errs.join(", ") : errs}`)
                .join(" | ");
              errorMsg += ` (${details})`;
            }
            this.errors = errorMsg;
            Swal.fire({
              title: "Error!",
              text: errorMsg,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getServiciosBusqueda();
        });
    },

    openAtributosModal: function (item) {
      this.selectedServicioAtributos = item;
      this.showAtributosModal = true;
    },

    closeAtributosModal: function () {
      this.showAtributosModal = false;
      this.selectedServicioAtributos = null;
    },

    showEdit: function (item, operation) {
      this.cargarFiltros(true);
      this.errors = null;
      this.editData = Object.assign({}, item);
      this.showModal = true;
      this.operation = operation;
      if (operation == "add") {
        this.disabled_id_tipo_suscripcion = false;
        this.disabled_id_operador = false;
        this.disabled_id_producto = false;
        this.disabled_id_keyword = false;
        this.disabled_secuencia = false;
        this.incompleto = true;
        this.editData.id_keyword = null;
        this.editData.id_producto = null;
        this.editData.id_tipo_suscripcion = 20;
        this.editData.id_operador = null;
        this.billing_sequence_select = "";
        this.cuadro = [];
      } else {
        this.getBillingSequence(item.id_servicio);
      }
    },

    agregarServicio: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.id_integrador = this.id_integrador_sel;
      delete this.editData.atributos;

      axios
        .post(process.env.VUE_APP_API_URL + "servicio/new", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            const createdSrv = (response.data && response.data.data) ? Object.assign({}, response.data.data) : {
              id_servicio: response.data && (response.data.id_servicio || response.data.id),
              id_producto: this.editData.id_producto,
              id_operador: this.editData.id_operador,
              id_keyword: this.editData.id_keyword,
              id_tipo_suscripcion: this.editData.id_tipo_suscripcion,
              keyword: this.editData.keyword,
              activo: this.editData.activo !== undefined ? this.editData.activo : 1,
            };
            if (!createdSrv.id_servicio && response.data && response.data.id_servicio) {
              createdSrv.id_servicio = response.data.id_servicio;
            }

            this.closeModal();
            this.openAtributosModal(createdSrv);
          }
        })
        .catch((e) => {
          const resData = e.response && e.response.data;
          if (resData) {
            let errorMsg = resData.error || "Ha ocurrido un error al intentar guardar";
            if (resData.errors && typeof resData.errors === "object" && Object.keys(resData.errors).length > 0) {
              const details = Object.entries(resData.errors)
                .map(([field, errs]) => `${field}: ${Array.isArray(errs) ? errs.join(", ") : errs}`)
                .join(" | ");
              errorMsg += ` (${details})`;
            }
            this.errors = errorMsg;
            Swal.fire({
              title: "Error!",
              text: errorMsg,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getServiciosBusqueda();
        });
    },

        getAtributosDefault: function () {
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "atributo/defecto")
        .then((response) => {
          this.atributosDefault = response.data.data;
          this.atributos.apigw_use_rbt=0;
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    getBillinSequences: function (forceRefresh = false) {
      this.billingsequences = [];
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "billingsequence/list", {
        id_integrador: this.id_integrador_sel,
      }, forceRefresh)
        .then((response) => {
          this.billingsequences = (response && response.data) ? (response.data.data || response.data) : [];
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

     getBillingSequence: function (id_servicio) {
      this.$store.commit("setLoading", true);
      return axios
        .post(process.env.VUE_APP_API_URL + "servicio/getBillingSequence", {
          id_servicio: id_servicio,
        })
        .then((response) => {
          if (response.data.billing_sequence_id) {
            this.billing_sequence_select = response.data.billing_sequence_id;
            this.getCuadroBilling(this.billing_sequence_select);
          } else {
            this.billing_sequence_select = "";
          }
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    getCuadroBilling: function (billingCodes) {
      this.$store.commit("setLoading", true);
      return axios
        .post(process.env.VUE_APP_API_URL + "billingcode/getCuadro", {
          billingCodes: billingCodes,
        })
        .then((response) => {
          if (response.data.precioFinal) {
            this.cuadro = response.data;
            //OBTENGO ATRIBUTOS QUE NO VAN A ESTAR MAS
            this.scPayments = response.data.sequence;
            this.scFrequency = response.data.scFrequency;
            this.scLifetime =response.data.scLifetime;
            this.scPrice = response.data.scPrice;
            this.scPriceImp = response.data.scPriceImp;
            this.billing_sequence_id = response.data.id_billing_sequence || response.data.id_Secuencia;
            this.billRestriction= response.data.billRestriction;
            //FIN DE OBTENGO ATRIBUTOS QUE NO VAN A ESTAR MAS
          } else {
            this.cuadro = "";
          }
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
    getProductosBusqueda: function (hideResult = true, forceRefresh = false) {
      if (hideResult) this.productos = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "producto/busqueda", {
        id_integrador: this.id_integrador_sel,
        get_all: true,
        activo: 1,
        order_by: { field: "id_producto", order: "ASC" },
      }, forceRefresh)
        .then((response) => {
          this.productos = (response && response.data) ? (response.data.data || response.data) : [];
        })
        .catch((e) => {
          this.errors.push(e);
           if (e.response && e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar los productos",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.post = true;
        });
    },
    getKeywordsBusqueda: function (hideResult = true, forceRefresh = false) {
      if (hideResult) this.keywordsBusqueda = [];
      this.post = false;
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "keyword/list", {
        id_integrador: this.id_integrador_sel,
        service: true,
      }, forceRefresh)
        .then((response) => {
          this.keywordsBusqueda = (response && response.data) ? (response.data.data || response.data) : [];
        })
        .catch((e) => {
          this.errors.push(e);
           if (e.response && e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las keywords",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.post = true;
        });
    },

    getCategorias: function (forceRefresh = false) {
      this.categorias = [];
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "categoria/list", {}, forceRefresh)
        .then((response) => {
          this.categorias = (response && response.data) ? (response.data.data || response.data) : [];
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },




    toggleEdit(variable){
      variable=false;
      return variable;
    },

    getError(name) {
      if (name) {
        return this.errors && this.errors.errors && this.errors.errors[name]
          ? this.errors.errors[name]
          : null;
      }
      return this.errors && this.errors.error ? this.errors.error : null;
    },

    checkpaso1(){
      if (
        this.editData.id_tipo_suscripcion &&
        this.editData.id_operador &&
        this.editData.id_producto &&
        this.editData.id_keyword
      ) {
        this.disabled_id_tipo_suscripcion=true;
        this.disabled_id_operador=true;
        this.disabled_id_producto=true;
        this.disabled_id_keyword=true;
        this.disabled_secuencia=true;
        this.incompleto = false;
      }else{

       Swal.fire({
            title: "Error!",
            text: "Seleccione los campos requeridos antes de continuar",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
      }
    },

    closeModal() {
      this.atributos=[];
      this.atributosOp=[];
      this.atributosTipoSusc=[];
      this.atributosServ=[];
      this.atributosFinal=[];
      this.disabled_id_tipo_suscripcion=false;
      this.disabled_id_operador=false;
      this.disabled_id_producto=false;
      this.disabled_id_keyword=false;
      this.disabled_secuencia=false;
      this.showModal = false;
      this.operation = null;
      this.incompleto = true;
    },
  },
};


</script>

<style scoped></style>
